import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAlertContext } from './Alerts';
import { useNavigate } from 'react-router-dom';

// Create the context
const ErrHandleContext = createContext();

// Create a custom hook to use the context
export const useErrHandleContext = () => {
    return useContext(ErrHandleContext);
};

// Create a provider component
export const ErrHandleProvider = ({ children }) => {

    const { failAlert } = useAlertContext();
    const navigate = useNavigate()

    const handleError = (err) => {
        console.log('err', err)
        if(err.response?.data?.status === 401){
            setTimeout(()=>{
                navigate('/')
            },3000)
            localStorage.removeItem("token");
            failAlert(true, 'You are not authorized to access this resource. Please log in to continue')
        }
    }
  
    return (
        <ErrHandleContext.Provider value={{ handleError }}>
        {children}
        </ErrHandleContext.Provider>
    );
};